import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.jsx'  // הגרסה המקורית
import AppV2 from './AppV2.jsx'  // הגרסה החדשה
import './index.css'
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsOfUse from "./pages/TermsOfUse.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import { initExternalScripts } from './utils/loadExternalScripts';
import { initScrollTracking } from './utils/loadGTM';

// Initialize scripts
initExternalScripts();

// Initialize scroll tracking after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollTracking);
} else {
  initScrollTracking();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* העמוד הראשי - הגרסה המקורית */}
        <Route path="/" element={<App />} />
        
        {/* גרסת A/B Testing - המסרים החדשים */}
        <Route path="/b" element={<AppV2 />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)